/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  var navImages = document.querySelectorAll('[data-image]')

  // Check when item is hovered and update closesr image '.header__dropdown__image' src
  if (navImages.length > 0) {
  var navimagelinklist = new Array();
  navImages.forEach(function (navitem) {
      navitem.addEventListener('mouseover', function (event) {
        var image = event.target.dataset.image;
        if(image){
          var dropdownContainer = this.closest('.header__dropdown__inner');
          dropdownContainer.querySelector('.header__dropdown__image img').src = image;
          dropdownContainer.querySelector('.header__dropdown__image img').srcset = image;
          dropdownContainer.querySelector('.header__dropdown__image').classList.add('deferred-media');
        }
      })
      navimagelinklist.push(navitem.dataset.image)
    })
    class imgPreloader {
      constructor() {

        this.images = new Array();

        this.addImages = function (images) {

          var self = this;

          if (!images) return;

          if (Array.isArray(images)) {
            images.forEach(function (ele) {
              var _image = new Image();
              _image.src = ele;
              self.images.push(_image);
            });
          }
        };

        return this;
      }
    }
    
    /* To use, simply pass in an array of  images */
    var newImage = new imgPreloader();

    newImage.addImages(navimagelinklist);
  }
  function formatPriceINR(x) {
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '')
        lastThree = lastThree;
    var result = "₹" + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return result;
  }
  var pricelist = document.querySelectorAll('.money');

  pricelist.forEach(price => {
    var priceinteger = price.textContent

    // remove first character from priceinteger (₹ sign)
    priceinteger = priceinteger.substring(1)
    
    price.textContent = formatPriceINR(priceinteger)
  });

  var productItemCarousels = document.querySelectorAll('.product-item__image .product__slides[data-product-slideshow]');

  // Function to initialize Flickity on each container
  function initFlickityOnContainers(carousels) {
    carousels.forEach((carousel) => {
      // Check if the carousel container exists
      if (carousel) {
        // Initialize Flickity on the carousel container
        new Flickity(carousel, {
          wrapAround: true,
          pageDots: true,
          prevNextButtons: false,
          autoPlay: true
          
          // Flickity options can be specified here
          // For example, you can set options like 'cellAlign', 'wrapAround', 'autoPlay', etc.
        });
      }
    });
  }

  // Call the function to initialize Flickity on all containers
  initFlickityOnContainers(productItemCarousels);


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
